<template>
  <div class="date-of-birth">
    <label>Date of {{ type }}*</label>
    <div class="date-of-birth-row">
      <Input
        :name="`dayOf${type}`"
        placeholder="DD"
        :label="`Day Of ${type}`"
        :required="true"
        :options="days"
        :startingValue="getStartingValue('day')"
        :customValidation="customValidationFunction"
        :vuexPath="vuexPath"
        ref="day"
      />
      <Input
        :name="`monthOf${type}`"
        placeholder="MM"
        :label="`Month Of ${type}`"
        :required="true"
        :options="monthOptions"
        optionValueKey="value"
        optionLabelKey="label"
        :startingValue="getStartingValue('month')"
        :customValidation="customValidationFunction"
        :vuexPath="vuexPath"
        ref="month"
      />
      <Input
        :name="`yearOf${type}`"
        placeholder="YY"
        :label="`Year Of ${type}`"
        :required="true"
        :options="years"
        :startingValue="getStartingValue('year')"
        :customValidation="customValidationFunction"
        :vuexPath="vuexPath"
        ref="year"
      />
    </div>

    <span v-if="showError" class="date-of-birth-field-error field-error">
      <span v-if="validateAge" v-html="validationMessage"></span>
      <span v-else>Please enter a valid date</span>
    </span>
  </div>
</template>

<script>
import Input from "@/vue/components/Form/Input.vue";
import { days, months, monthOptions, years } from "@/utils";

export default {
  components: {
    Input,
  },

  props: {
    type: {
      type: String,
      default: "Birth",
    },
    startingValue: {
      type: Object,
    },
    validateAge: {
      type: Number,
      default: 0,
    },
    customValidation: {
      type: Function,
      default: null,
    },
    vuexPath: {
      type: Array,
    },
    years: {
      type: Array,
      default: () => years,
    },
    under18ErrorMessage: {
      type: String,
    },
  },

  data() {
    return {
      days,
      months,
      monthOptions,
      fieldNames: [
        `dayOf${this.type}`,
        `monthOf${this.type}`,
        `yearOf${this.type}`,
      ],
      customValidationFunction: this.customValidation,
    };
  },

  computed: {
    values() {
      return this.$store.getters.formDataFlat(this.vuexPath);
    },

    showError() {
      for (const fieldName of this.fieldNames) {
        const showFieldError = this.$store.getters.showFieldError({
          name: fieldName,
          vuexPath: this.vuexPath,
        });
        if (showFieldError) {
          return true;
        }
      }
      return false;
    },

    age() {
      const date = new Date();
      date.setMonth(
        this.values[`monthOf${this.type}`] - 1,
        this.values[`dayOf${this.type}`]
      );
      date.setYear(this.values[`yearOf${this.type}`]);
      date.setHours(0, 0, 0);

      const ageDiffMs = Date.now() - date.getTime();
      const ageDate = new Date(ageDiffMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },

    validationMessage() {
      if (this.under18ErrorMessage == "")
        return `Please ensure age is ${this.validateAge} years or older`;
      return this.under18ErrorMessage;
    },
  },

  created() {
    if (this.validateAge) {
      this.$watch("values", this.watchValues);
      this.customValidationFunction = this.ageValidation;
    }
  },

  methods: {
    getStartingValue(period) {
      return (
        this.startingValue && this.startingValue[`${period}Of${this.type}`]
      );
    },

    watchValues(newValues, oldValues) {
      for (const fieldName of this.fieldNames) {
        if (newValues[fieldName] !== oldValues[fieldName]) {
          this.$refs.day.setFieldError();
          this.$refs.month.setFieldError();
          this.$refs.year.setFieldError();
          break;
        }
      }
    },

    /** check date against an age passed in by props */
    ageValidation() {
      return {
        valid: this.age >= this.validateAge,
        message: this.validationMessage,
      };
    },
  },
};
</script>
